import { apiFetch } from '../client';

export function addUserDFRList(){
    return apiFetch('/add_user_dfr_list/',{
        method: 'POST',
    })
}

export function sendEvent(name, data){
    return apiFetch('/send-event/', {
        method: 'POST',
        body: JSON.stringify({event_name: name, event_data: data})
    })
}

export function getMunis(){
    return apiFetch('/get-muni-list/', {
        method: 'GET'
    })
}
